import { Pipe, PipeTransform } from '@angular/core'
import { titlecase } from '@mmx/shared'

@Pipe({
  name: 'mmxTitlecase',
  standalone: true,
})
export class MMXTitleCasePipe implements PipeTransform {
  transform(text: string): string {
    return titlecase(text)
  }
}
